import { CouponType } from "@modules/common/couponObject/gateway/couponObjectApiDto"
import { word } from "@modules/core/utils/i18n"
import { useProgramBundles } from "@modules/programBundle/hooks/useProgramBundle"
import { ProgramReductionItem } from "@modules/promoCode/components/programReductionItem"
import { HUCheckbox } from "@modules/ui/components/huCheckbox"
import { HUText } from "@modules/ui/components/huText"
import { HURow, HUStack } from "@modules/ui/components/layout"
import { useTheme } from "styled-components"

export const ProgramBundleListSelection: React.FC<{
  selectedProgramIds: string[]
  onSelectProgram: (id: string) => void
  onSelectAllPrograms: (allIds: string[]) => void
  promoCodeValue?: number
  promoCodeType?: CouponType
  promoCodeDuration?: number
  error?: React.JSX.Element
}> = ({
  selectedProgramIds,
  onSelectProgram,
  onSelectAllPrograms,
  promoCodeType,
  promoCodeValue,
  promoCodeDuration,
  error,
}) => {
  const { data: programs } = useProgramBundles(null, true)
  const theme = useTheme()

  if (!programs || programs.length === 0) return null

  return (
    <>
      <HUText
        type="label"
        color={theme.neutralColor700}
        fontStyle="LS"
        style={{ lineHeight: "21px", marginBottom: 7 }}
        className="mt-4"
      >
        {word("promoCode.form.input.relatedProgramBundle").toUpperCase()}
        <HUText fontStyle="LL" color={theme.necessaryInput}>
          {" *"}
        </HUText>
      </HUText>
      <HUStack>
        <HURow className="align-items-center justify-content-between mb-2">
          <HUText fontStyle="LL">{word("global.filters.selectAll")}</HUText>
          <HUCheckbox
            inputKey={""}
            name="option"
            checked={programs.length === selectedProgramIds.length}
            onChange={() => onSelectAllPrograms(programs.map((program) => program.id))}
            color={theme.primaryColor}
            checkIconColor={theme.neutralColor700}
          />
        </HURow>

        {programs.map((program) => (
          <HURow key={program.id} className="align-items-center justify-content-between">
            <ProgramReductionItem
              key={program.id}
              program={program}
              promoCodeType={promoCodeType}
              promoCodeValue={promoCodeValue}
              promoCodeDuration={promoCodeDuration}
            />
            <HUCheckbox
              name="option"
              checked={!!selectedProgramIds.find((id) => id === program.id)}
              onChange={() => onSelectProgram(program.id)}
              color={theme.primaryColor}
              checkIconColor={theme.neutralColor700}
              inputKey={program.id}
              data-testid={program.id}
            />
          </HURow>
        ))}

        {error}
      </HUStack>
    </>
  )
}
